import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonModify, ManageButton } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import ContainerIndex from '../../layouts/containers/container-index';
import IndexCard from '../../components/cards/index-card';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import { SmallPill } from '../../components/pills';
import SearchBar from '../../components/searchbar';
import Eye from '../../components/buttons/eye';
import Book from '../../components/buttons/book';
import Scrollable from '../../components/scrollable';
import LatestUpdates from '../dashboard/components/component-latest-updates';

const el = document.getElementById('activity-index');

if (el) {
    ReactDOM.render(
        <Layout 
            topLeft={<Welcome title="Welcome to your" subtitle="Activity" theme="light"/>}
            topRight={
                <Row gap="20px">
            
                </Row>
            }
        >
            <SeventyThirtyLayout
                main={
                    <Container>
                        <Container.Header>
                            <Row gap="20px">
                                <Container.Icon src="/assets/icons/trophy.svg"/>
                                <Container.Text fontSize="18px" fontWeight="500" color="#FCFCFC">Activity</Container.Text>
                            </Row>
                        </Container.Header>

                        <Container.Content>
                            <ContainerIndex>
                                <ContainerIndex.Filters>
                                    <List gap="20px" style={{ width: '100%' }}>
                                        <SearchBar/>
                                        <Row gap="20px" wrap>
                                            <InputsDropdown/>
                                            <InputsDropdown/>
                                        </Row>
                                    </List>
                                    <Row gap="10px" wrap>
                                        { new Array(10).fill(0).map(() => <SmallPill>Category #</SmallPill>)}
                                    </Row>
                                </ContainerIndex.Filters>

                                <ContainerIndex.Content>
                                    { new Array(8).fill(0).map(() => {
                                        return (
                                            <IndexCard
                                                image="/images/office.png"
                                                title={'Title'}
                                                subtitle={'Subtitle'}
                                                infos={[
                                                    {
                                                        label : 'LABEL',
                                                        value : '8'
                                                    },
                                                    {
                                                        label : 'LABEL',
                                                        value : '8'
                                                    }
                                                ]}
                                                buttons={
                                                    <>
                                                        <Button color="black" transparent leftIcon={<Eye/>}>Overview</Button>
                                                        <Button color="black" transparent leftIcon={<Book/>}>Book</Button>
                                                    </>
                                                }
                                            />
                                        )
                                    })}
                                </ContainerIndex.Content>

                                <ContainerIndex.Pagination/>
                            </ContainerIndex>
                        </Container.Content>
                    </Container>
                }
                sectionOne={
                    {
                        name: 'Side',
                        component: (
                            <Container>
                                <Container.Header>
                                    <Row gap="20px">
                                        <Container.Icon src="/assets/icons/trophy.svg"/>
                                        <Container.Text fontSize="18px" fontWeight="500" color="#FCFCFC">Latest DMC Updates</Container.Text>
                                    </Row>
                                </Container.Header>

                                <Container.Content>
                                    <LatestUpdates/>
                                </Container.Content>
                            </Container>
                        )
                    }
                }
            />
        </Layout>    
    , el);
}
